module.exports = __webpack_public_path__ + "img/illu-card-beschwerden-swelling.f7b863ea.svg";